module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"menu":{"delete":"削除"},"field":{"original":"撮影画像を表示","total":"頭数合計"},"msg":{"download":{"failed":"画像のダウンロードに失敗しました。"}}},"en":{"menu":{"delete":"Delete"},"field":{"original":"Show original photo","total":"Total"},"msg":{"download":{"failed":"Failed to download image."}}}}')
  delete Component.options._Ctor
}
